import { GETSTARTEDSTATE } from '../constants';
import { ReactNode } from 'react';

export const getStartedState = (getStartedState: string) => {
	return {
		type: GETSTARTEDSTATE,
		getStartedState,
	};
};
